import React from 'react';
import { reduxForm, InjectedFormProps, Field, Form } from 'redux-form';
import FormHelperText from '@material-ui/core/FormHelperText';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import Button from 'components/Button/Button';
import Fields from 'components/Fields';
import { useFormatMessage } from 'components/IntlProvider';

export interface ProfileValuesTypes {
  [key: string]: string;
}

const useStyles = makeStyles((theme) => ({
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
}));

const User = ({ handleSubmit, error, submitting }: InjectedFormProps) => {
  const classes = useStyles();
  const t = useFormatMessage();
  return (
    <Form onSubmit={handleSubmit} className={classes.form} noValidate>
      <Grid container justify="center" spacing={3}>
        <Grid item xs={12} sm={6}>
          <Field
            component={Fields.Text}
            variant="outlined"
            margin="normal"
            fullWidth
            label="UUID"
            name="uuid"
            helpertext={t(
              'user.uuid.helpertext',
              'Universally unique identifier'
            )}
            autoComplete="off"
            InputLabelProps={{
              shrink: true,
            }}
            disabled
          />
          <Field
            component={Fields.Text}
            variant="outlined"
            margin="normal"
            fullWidth
            label={t('user.email', 'Email')}
            name="email"
            autoComplete="off"
            InputLabelProps={{
              shrink: true,
            }}
            disabled
          />
          <Field
            component={Fields.Text}
            variant="outlined"
            margin="normal"
            fullWidth
            label={t('user.language', 'Language')}
            name="language"
            autoComplete="off"
            InputLabelProps={{
              shrink: true,
            }}
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            component={Fields.Text}
            variant="outlined"
            margin="normal"
            fullWidth
            label={t('user.username', 'Username')}
            name="username"
            autoComplete="off"
            InputLabelProps={{
              shrink: true,
            }}
          />
          <Field
            component={Fields.Text}
            variant="outlined"
            margin="normal"
            fullWidth
            label={t('user.firstname', 'First name')}
            placeholder="Jonathan"
            name="first_name"
            autoComplete="off"
            InputLabelProps={{
              shrink: true,
            }}
          />
          <Field
            component={Fields.Text}
            variant="outlined"
            margin="normal"
            fullWidth
            label={t('user.lastname', 'Last name')}
            placeholder="Dean"
            name="last_name"
            autoComplete="off"
            InputLabelProps={{
              shrink: true,
            }}
          />
          <Field
            component={Fields.Phone}
            margin="normal"
            fullWidth
            placeholder={t('user.phone', 'Phone')}
            name="phone"
          />
        </Grid>
      </Grid>
      <Grid container justify="center" spacing={3}>
        <Grid item xs={12}>
          {error && <FormHelperText error>{error}</FormHelperText>}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.submit}
            isLoading={submitting}
          >
            {t('forms.profile.save', 'Save')}
          </Button>
        </Grid>
      </Grid>
    </Form>
  );
};

export default reduxForm({
  form: 'userOrganization',
})(User);
